import $ from 'jquery';
import {updateTicketCategoryPrices} from '../helpers/packageTypeHelpers';

class PackageTypeSelector {
    constructor(arrangementPage) {
        this.arrangementPage = arrangementPage;
        this.initializeDefaultSelection();
        $('.package-type-selector').on('click', '.package-type-row', this.handlePackageTypeClick.bind(this));
    }
    
    initializeDefaultSelection() {
        const $firstRadio = $('.package-type-radio-input').last();
        
        if ($firstRadio.length) {
            $firstRadio.prop('checked', true);
            updateTicketCategoryPrices($firstRadio.val());
        }
    }

    handlePackageTypeClick(event) {
        const $row = $(event.currentTarget),
         $radio = $row.find('.package-type-radio-input'),
         packageType = $radio.val();
        
        $radio.prop('checked', true);
        
        $('.package-type-row').removeClass('active');
        
        updateTicketCategoryPrices(packageType);
        
        if ($('#arrangementPage').hasClass('openedWidget')) {
            $('#arrangementPage, .headerContainer, #searchWidget').removeClass('openedWidget');
        }
        
        this.scrollToElement($('#ticketCategoriesBlock'));
        
        this.openWidget(packageType);
    }

    scrollToElement($element, offset = 100) {
        if ($element.length) {
            $('html, body').animate({'scrollTop': $element.offset().top - offset}, 200);
        }
    }

    openWidget(packageType) {
        $(document).one('widgetReady', () => {
            this.continueWithWidget(packageType);
        });
        this.arrangementPage.loadWidget();
    }

    continueWithWidget(packageType) {
        const $widget = $('#searchWidget'),
         $ticketCategories = $('#ticketCategoriesBlock');

        if (!$widget.hasClass('openedWidget')) {
            this.scrollToElement($ticketCategories);
        }
        
        this.selectPackage(packageType);
    }
    
    selectPackage(packageType) {
        $('.amandedPackageSearchFlow-eventBlock').first().trigger('click');
        $(`.amandedPackageSearchFlow-packageBlock-btn[data-packagetype="${packageType}"]`).trigger('click');
    }
}

export default PackageTypeSelector;